// extracted by mini-css-extract-plugin
export default {"main":"xZFjCTYNameyiw0p3Tro"};